/* HeyBear · Bear run: a road drawn through the three step cards; the car drives it as you scroll,
   flips to face the way it is going (also when scrolling back up) and parks behind the 7-Eleven. */
HB.section('bear-run', function (root) {
  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var off = [], on = function (el, ev, fn, o) { el.addEventListener(ev, fn, o); off.push(function () { el.removeEventListener(ev, fn, o); }); };
  HB.reveal(root);
  var run = root.matches('#run') ? root : $('#run'), svg = $('#runSvg'), car = $('#runCar'), carImg = $('#runCarImg');
  var IMG = { L: run.getAttribute('data-car-l'), R: run.getAttribute('data-car-r') };
  var path, len = 0, facing = 'R', lastP = 0, back = false, bt;
  function build() {
    var W = run.clientWidth, H = run.clientHeight, rb = run.getBoundingClientRect();
    var mob = W < 900, rows = $$('.run-row');
    var hb = $('.run-head').getBoundingClientRect().bottom - rb.top, pts = [[mob ? W * .82 : W * .5, hb + (mob ? 40 : 10)]];
    rows.forEach(function (r, i) {
      var c = r.querySelector('.run-card').getBoundingClientRect();
      if (mob) pts.push([i % 2 ? W * .82 : W * .18, c.top - rb.top - 90]);
      else { var side = i % 2 ? (c.left - rb.left) / 2 : (c.right - rb.left) + (W - (c.right - rb.left)) / 2; pts.push([side, c.top - rb.top + c.height / 2]); }
    });
    var si = $('#runEnd img').getBoundingClientRect(); pts.push([W * .5, si.top - rb.top + si.height * .62]);
    /* catmull-rom -> bezier */
    var d = 'M' + pts[0][0] + ',' + pts[0][1];
    for (var i = 0; i < pts.length - 1; i++) {
      var p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || p2, t = .5;
      d += ' C' + (p1[0] + (p2[0] - p0[0]) * t / 2) + ',' + (p1[1] + (p2[1] - p0[1]) * t / 2) + ' ' + (p2[0] - (p3[0] - p1[0]) * t / 2) + ',' + (p2[1] - (p3[1] - p1[1]) * t / 2) + ' ' + p2[0] + ',' + p2[1];
    }
    var w = mob ? 54 : 72;
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.innerHTML = '<path class="edge" d="' + d + '" stroke-width="' + (w + 8) + '"/><path class="tar" d="' + d + '" stroke-width="' + w + '"/><path class="dash" id="runPath" d="' + d + '"/>' +
      pts.slice(1, -1).map(function (p, i) { return '<g class="pin" transform="translate(' + p[0] + ',' + p[1] + ')"><circle r="' + (mob ? 16 : 20) + '"/><text>' + (i + 1) + '</text></g>'; }).join('');
    path = svg.querySelector('#runPath'); len = path.getTotalLength(); tick();
  }
  function tick() {
    if (!path) return;
    var r = run.getBoundingClientRect(), vh = innerHeight;
    var p = (vh * .55 - r.top - 200) / (r.height - 200 - vh * .25); p = Math.max(0, Math.min(1, p));
    var L = p * len, pt = path.getPointAtLength(L), pt2 = path.getPointAtLength(Math.min(len, L + 2)), pt0 = path.getPointAtLength(Math.max(0, L - 2));
    var dx = pt2.x - pt0.x, dy = pt2.y - pt0.y;
    if (Math.abs(p - lastP) > .0005) { back = p < lastP; lastP = p; }
    if (back) { dx = -dx; dy = -dy; }
    var f = dx < -0.2 ? 'L' : dx > 0.2 ? 'R' : facing; if (f !== facing) { facing = f; carImg.src = IMG[f]; }
    var ang = Math.atan2(dy, Math.abs(dx)) * 180 / Math.PI; ang = Math.max(-28, Math.min(28, ang)); if (facing === 'L') ang = -ang;
    car.style.transform = 'translate(' + (pt.x - car.offsetWidth / 2) + 'px,' + (pt.y - car.offsetHeight * .82) + 'px) rotate(' + ang + 'deg)';
    $('#runTag').classList.toggle('on', p > .97);
  }
  var raf;
  on(window, 'scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(tick); }, { passive: true });
  on(window, 'resize', function () { clearTimeout(bt); bt = setTimeout(build, 120); });
  build(); if (document.fonts) document.fonts.ready.then(build); var t8 = setTimeout(build, 800);
  off.push(function () { clearTimeout(t8); clearTimeout(bt); cancelAnimationFrame(raf); });
  return function () { off.forEach(function (fn) { fn(); }); };
});
